import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {postMessage} from "../../slice/chat.slice";

export default function ReplyOptions() {
    const dispatch = useDispatch();
    const hasMessages = useSelector((state) => state.chat.messages.length > 0);
    const replyOptions = useSelector((state) => state.chat.replyOptions);

    if (!hasMessages || replyOptions.length === 0) {
        return null;
    }

    return (
        <div className="sb-chat--btn-bar sb-suggestions">
            {replyOptions.map((option, index) => (
                <button
                    key={index}
                    className="btn btn--secondary-outline sb-suggestions--chip"
                    type="button"
                    onClick={() => dispatch(postMessage({message: option}))}
                >
                    <span className={"btn__txt"}>{option}</span>
                </button>
            ))}
        </div>
    );
}
